import React, { Component } from 'react';
import { Icon, Button } from 'antd';
import { Document, Page } from 'react-pdf/dist/entry.webpack';

export class PdfPreview extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      hover: false,
      pdfRendered: false,
      loadFailed: false
    };

    this.onClick = this.onClick.bind(this);
    this.onPointerEnter = this.onPointerEnter.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this.onRenderSuccess = this.onRenderSuccess.bind(this);
    this.onLoadError = this.onLoadError.bind(this);
  }

  onClick() {
    window.open(this.props.pdf, '_blank');
  }

  onPointerEnter() {
    this.setState({ hover: true });
  }

  onPointerLeave() {
    this.setState({ hover: false });
  }

  onRenderSuccess() {
    this.setState({ pdfRendered: true });
  }

  onLoadError() {
    this.setState({ loadFailed: true });
  }

  render() {
    return (
      <div>
        {this.state.loadFailed ? (
          <div>
            <Button type="primary" icon="download" size="large" href={this.props.pdf}>
              Spara PDF
            </Button>
          </div>
        ) : (
          this.props.pdf && (
            <Document
              loading="hämtar pdf..."
              error="Misslyckades att ladda pdf"
              file={this.props.pdf}
              onMouseEnter={this.onPointerEnter}
              onMouseLeave={this.onPointerLeave}
              onLoadError={this.onLoadError}
            >
              <Page onRenderSuccess={this.onRenderSuccess} pageNumber={1}>
                {this.state.hover &&
                  this.state.pdfRendered && (
                    <div
                      onClick={this.onClick}
                      style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255,255,255, 0.6)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1,
                        color: 'rgba(0, 0, 0, 0.7)',
                        fontSize: 80,
                        cursor: 'pointer'
                      }}
                    >
                      <Icon type="download" style={{ fontSize: 160, color: 'rgba(0, 0, 0, 0.7)' }} />
                      Spara PDF
                    </div>
                  )}
              </Page>
            </Document>
          )
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PdfPreview.js